var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row form-group table-filter" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _vm.title
          ? _c("label-control", {
              staticClass: "col-form-label",
              attrs: { title: _vm.title, forElement: _vm.id }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 col-sm-6 col-md-4 col-lg-3" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.modifiedValue,
            expression: "modifiedValue"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          id: _vm.id,
          maxlength: _vm.maxLength,
          placeholder: _vm.$t(_vm.placeholder),
          "aria-labelledby": _vm.labelledBy ? _vm.labelledBy : null
        },
        domProps: { value: _vm.modifiedValue },
        on: {
          keyup: function($event) {
            return _vm.filterFunction()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.modifiedValue = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 col-sm-6 col-md-8 col-lg-9 col-form-label right",
        attrs: { "aria-atomic": "true", "aria-live": "polite" }
      },
      [
        _c("span", { staticClass: "sr-only" }, [
          _vm._v(_vm._s(_vm.$t(_vm.resultsAriaText)) + " ")
        ]),
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("Total")) +
            ": " +
            _vm._s(_vm.results) +
            " " +
            _vm._s(_vm.$t("Pcs")) +
            "\n  "
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }